import React, { useEffect, useRef } from 'react';
import { BiContainer } from "./BiContainer/BiContainer";
import { BiContext, useBiContextGetter } from "./BiContext";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function useModalViewEvent(biName, biData) {
  const getBiContext = useBiContextGetter();
  const hasSentModalView = useRef(false);
  useEffect(() => {
    const context = getBiContext();
    if (context && biName && !hasSentModalView.current) {
      hasSentModalView.current = true;
      context.logBiModalView({
        modalName: biName,
        data: biData
      });
    }
  }, [getBiContext, biName, biData]);
}
function BiModalContainerInner(_ref) {
  let {
    children,
    biName,
    biData
  } = _ref;
  // Send modal_view event using the (possibly bridged) parent context
  useModalViewEvent(biName, biData);

  // Use BiContainer to handle hierarchy and data enrichment
  return /*#__PURE__*/_jsx(BiContainer, {
    name: biName,
    data: biData,
    children: children
  });
}
export function BiModalContainer(_ref2) {
  let {
    children,
    biName,
    biData,
    biCallerContext
  } = _ref2;
  const getBiContext = useBiContextGetter();
  if (biCallerContext) {
    return /*#__PURE__*/_jsx(BiContext.Provider, {
      value: biCallerContext,
      children: /*#__PURE__*/_jsx(BiModalContainerInner, {
        biName: biName,
        biData: biData,
        children: children
      })
    });
  }

  // No bridging needed, just use the existing context
  if (getBiContext()) {
    return /*#__PURE__*/_jsx(BiModalContainerInner, {
      biName: biName,
      biData: biData,
      children: children
    });
  }

  // No context at all, just render children
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}